<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -moz-user-select: none; /* 火狐 */
  -webkit-user-select: none; /* 谷歌、Safari */
  -ms-user-select: none; /* IE10+ */
  user-select: none;
  user-drag: none;
}
/*设置滚动条的背景色。*/
/* ::-webkit-scrollbar-track {
  display: none;
} */
@media screen and (min-width: 821px) {
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 0;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(156, 153, 153, 0.3);
    border-radius: 4px;
  }
}
@media screen and (max-width: 768px) {
  .el-message-box {
    max-width: 300px;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue